<template>
    <a-modal
        centered
        :visible="visible"
        title="审批设置"
        @ok="on_store"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="360"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="approve-create">
            <a-form-model-item label="订单放款审批">
                <a-select v-model="form.order_loan">
                    <a-select-option v-for="item in basic_data_user" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="账户余额退款审批">
                <a-select v-model="form.balance_refund">
                    <a-select-option v-for="item in basic_data_user" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="客户充值审批">
                <a-select v-model="form.recharge">
                    <a-select-option v-for="item in basic_data_user" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                </a-select>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    export default {
        props: {
            visible: {
                default: false,
            },
            callback: null,
            record: null,
        },
        data() {
            return {
                submitting: false,
                form: {
                    group_id: null,
                },
            };
        },
        created() {
            this.load_basic_user();
        },
        watch: {
            visible(v) {
                if (v && this.record) {
                    this.record.approve.map((v) => {
                        this.$set(this.form, v.name, v.value);
                    });
                    this.form.group_id = this.record.id;
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["approve-create"].validate((valid) => {
                    if (valid) {
                        this.on_store();
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_store() {
                this.submitting = true;
                this.$http
                    .post("/auth/group/approve", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$message.success(res.message);

                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch()
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["approve-create"].resetFields();

                this.form = {};
            },
        },
    };
</script>
